var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","justify-center":"","align-center":""}},[(_vm.title)?_c('h2',[_vm._v(_vm._s(((_vm.$t(_vm.title)) + " " + (_vm.unit ? ("(" + _vm.unit + ")") : ''))))]):_vm._e(),_c('div',{attrs:{"id":"chartdiv"}})])}
var staticRenderFns = []

export { render, staticRenderFns }